/**
 * Styled Components - Created by cazarez on 27/02/18.
 */
import styled from 'styled-components'
import breadcrumb from 'antd/lib/breadcrumb'
import icon from 'antd/lib/icon'
import { RED } from '../../theme/colors'

interface StyleProps {
  showChildren?: boolean
  color?: string
}

export const Container = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  padding: 31px 36px 32px 32px;
  background-color: #fff;

  @media (min-width: 320px) and (max-width: 768px) {
    padding: 31px 5px 32px 5px;
  }
`

export const Text = styled.div`
  color: #5f6062;
`
export const FiltersColumn = styled.div`
  flex: 1 1 auto;
`

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const FiltersTitle = styled.div`
  display: ${({ showChildren }: StyleProps) =>
    showChildren ? 'inline-block' : 'none'};
  height: 36.95px;
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  margin-bottom: 15px;
  position: relative;
  z-index: 4;
  ${({ color }: StyleProps) => `color: ${color};`};
`

export const CloseButton = styled(icon)`
  z-index: 11;
  position: fixed;
  left: 229px;
  top: 12px;
  border-radius: 7px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: none;
  padding: 8px 10px;
  color: black;
  background: white;
  box-shadow: 3px 3px 4px -4px #333333;
  border-block: 1px solid gray;
  border-right: 1px solid gray;
  animation: fade-in-mask .3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
`

export const Mask = styled.div`
  background: #0000004d;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 1;
  animation: fade-in-mask .3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-mask {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const ResultsColumn = styled.div`
  flex: 10;

  @media (min-width: 768px) and (max-width: 1024px) {
  }

  @media (min-width: 481px) and (max-width: 767px) {
  }

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
  .goBack {
    margin-bottom: 18px;
    margin-left: 12px;
    margin-top: -10px;
    font-size: 16px;
    font-weight: bold;
    font-family: Avenir;
    z-index: 4;
    position: relative;
    i {
      margin-right: 6px;
    }
  }
`

export const StyledBreadcrumb = styled(breadcrumb)`
  background-color: #fff;
  padding: 10.5px 0 10.5px 48px;
  border: 1px solid #dcdcdc;
`

export const MenuStyle = {
  width: '200px'
}

export const Icon = styled(icon)`
  color: ${RED};
`

export const GoBack = styled.div`
  margin-bottom: 18px;
  margin-left: 12px;
  margin-top: -10px;
  font-size: 16px;
  font-weight: bold;
  font-family: Avenir;
  z-index: 4;
  i {
    margin-right: 6px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductCatalogue/styledComponents.tsx